import { ContentPage } from "containers/ContentPage";
import { getDocByUID, getDocs } from "shared/prismic";
import * as prismic from "@prismicio/client";

export async function getStaticProps({ preview = null, previewData, params }) {
  const { slug } = params;
  const uid = slug[slug.length - 1];
  const doc = await getDocByUID({ previewData, uid });
  return { props: { doc, preview } };
}

export async function getStaticPaths() {
  const results = await getDocs({ type: "page" });
  const paths = results.map((page) => prismic.asLink(page));
  return { paths, fallback: false };
}

export default ContentPage;
